import * as actionTypes from "../../constants/actionTypes";

const hasChangedFilters = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.RESET_HAS_CHANGED_FILTERS:
      return {};
    case actionTypes.UPDATE_HAS_CHANGED_FILTER:
      return { ...state, [action.id]: true };
    default:
      return state;
  }
};

export default hasChangedFilters;
